import { booleanAttribute, Directive, HostListener, Input, OnInit } from '@angular/core';
import { NAVIGATION_KEYS } from '../consts/keys.const';

@Directive({
  selector: '[appNumbersOnly]',
  standalone: true
})
export class NumbersOnlyDirective implements OnInit {
  @Input({ transform: booleanAttribute }) allowSpaces = false;

  numbersPattern;
  _enabled = true;

  ngOnInit(): void {
    this.numbersPattern = this.allowSpaces ? /^[\d\s]*$/ : /^\d*$/;
  }

  get enabled() {
    return this._enabled;
  }

  @Input('numbersOnly')
  set enabled(v: string | boolean) {
    if (v !== null && v !== '') {
      this._enabled = v as boolean;
    }
  }

  @HostListener('keydown', ['$event']) onInputChange(event) {
    if (this.enabled) {
      if (this.isAcceptedKey(event)) {
        return;
      }
      if (event.key === ' ' || isNaN(Number(event.key))) {
        event.preventDefault();
      }
    }
  }

  @HostListener('drop', ['$event'])
  @HostListener('paste', ['$event'])
  onDropPaste(event) {
    if (this.enabled) {
      const value =
        event instanceof DragEvent ? (event.target as HTMLInputElement).value : event.clipboardData.getData('text');
      if (this.numbersPattern.test(value)) {
        return;
      } else {
        event.preventDefault();
      }
    }
  }

  private isAcceptedKey(event: KeyboardEvent): boolean {
    return (
      NAVIGATION_KEYS.indexOf(event.key) > -1 ||
      (event.key === 'a' && event.ctrlKey === true) ||
      (event.key === 'c' && event.ctrlKey === true) ||
      (event.key === 'v' && event.ctrlKey === true) ||
      (event.key === 'x' && event.ctrlKey === true) ||
      this.numbersPattern.test(event.key)
    );
  }
}
